import { createFileRoute } from "@tanstack/react-router";

import SolutionEdit from "../pages/Solutions/SolutionEdit";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/solutions/$orgId")({
  component: SolutionEditRoute,
});

function SolutionEditRoute() {
  return (
    <RequireAuth require="adminOrLimitedAdmin">
      <SolutionEdit />
    </RequireAuth>
  );
}
